import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token and business ID
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    const businessId = localStorage.getItem('businessId') || 'default-business-id'
    console.log('token', token)
    console.log('businessId', businessId)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (businessId) {
      config.headers['business-id'] = businessId
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('sessionToken')
      window.location.href = '/signin'
    }
    return Promise.reject(error)
  }
)

export const visualFlowAPI = {
  // Get all visual flows
  getAllFlows: () => {
    console.log('VisualFlowAPI: Get all flows request')
    return api.get('/api/visual/flow/all')
  },

  // Get flow by intent key
  getFlowByIntentKey: (intentKey) => {
    console.log('VisualFlowAPI: Get flow by intent key request:', intentKey)
    return api.get(`/api/visual/flow?intentKey=${intentKey}`)
  },

  // Create or update flow
  createOrUpdateFlow: (flowData) => {
    console.log('VisualFlowAPI: Create/update flow request:', flowData)
    
    // Create FormData for multipart/form-data request
    const formData = new FormData()
    formData.append('intentKey', flowData.intentKey || 'default-intent')
    formData.append('title', flowData.title)
    formData.append('description', flowData.description || '')
    
    // Add steps if provided
    if (flowData.steps && flowData.steps.length > 0) {
      console.log('Adding steps to FormData:', flowData.steps)
      flowData.steps.forEach((step, index) => {
        console.log(`Step ${index}:`, step)
        formData.append(`steps[${index}][title]`, step.title || '')
        formData.append(`steps[${index}][description]`, step.description || '')
        if (step.media && step.media instanceof File) {
          console.log(`Adding media for step ${index}:`, step.media.name, step.media.size)
          formData.append(`steps[${index}][media]`, step.media)
        } else if (step.media_asset_id) {
          formData.append(`steps[${index}][media_asset_id]`, String(step.media_asset_id))
        } else {
          console.log(`No media for step ${index}`)
        }
      })
    }
    
    // Debug FormData contents
    console.log('FormData contents:')
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value)
    }
    
    return api.post('/api/visual/flow', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Update flow
  updateFlow: (flowId, flowData) => {
    console.log('VisualFlowAPI: Update flow request:', flowId, flowData)
    
    // Create FormData for multipart/form-data request
    const formData = new FormData()
    formData.append('intentKey', flowData.intentKey || 'default-intent')
    formData.append('title', flowData.title)
    formData.append('description', flowData.description || '')
    
    // Add steps if provided
    if (flowData.steps && flowData.steps.length > 0) {
      console.log('Adding steps to FormData:', flowData.steps)
      flowData.steps.forEach((step, index) => {
        console.log(`Step ${index}:`, step)
        formData.append(`steps[${index}][title]`, step.title || '')
        formData.append(`steps[${index}][description]`, step.description || '')
        if (step.media && step.media instanceof File) {
          console.log(`Adding media for step ${index}:`, step.media.name, step.media.size)
          formData.append(`steps[${index}][media]`, step.media)
        } else if (step.media_asset_id) {
          formData.append(`steps[${index}][media_asset_id]`, String(step.media_asset_id))
        } else {
          console.log(`No media for step ${index}`)
        }
      })
    }
    
    // Debug FormData contents
    console.log('FormData contents:')
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value)
    }
    
    return api.put(`/api/visual/flow/${flowId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // Delete flow
  deleteFlow: (flowId) => {
    console.log('VisualFlowAPI: Delete flow request:', flowId)
    return api.delete(`/api/visual/flow/${flowId}`)
  }
}

export default visualFlowAPI
